import "./about.css";
import work from "../../img/aboutlft.jpg";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src={work}
            alt=""
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">
        This is Fariha Hasan Kathika.Working as a Front end developer at WerIt(Software Company)
        </p>
        <p className="a-desc">
        As a Developer I dont say I know everything or I know nothing.But I am a learner So I have something and always try to do something that makes me unique. I love challenges and prefer to challange my limits more than limit my challanges
        </p>
        <div className="a-award">
          <img src={"https://i.ibb.co/VW9NZ24/phero-certificate.png"} alt="" className="a-award-img" />
          <div className="a-award-texts">
            <h4 className="a-award-title">Certified from programming hero(Batch-4)</h4>
            <p className="a-award-desc">
    website:        
<a href="https://web.programming-
hero.com/">Programming Hero</a>
<br />
<a href="https://i.ibb.co/VW9NZ24/phero-certificate.png">Programming Hero Certificate</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
